import { DataTable, TableProvider } from "@xest-ui/data-table";
import MyPaginator from "components/PaginatedTable/MyPaginator";
import { DefaultTableComponents } from "components/PaginatedTable/DefaultTableComponents";
import { useHistory, useLocation } from "react-router-dom";
import updateQueryParams from "components/PaginatedTable/updateQueryParams";
import React from "react";
import getNotifymeUsers from "services/getNotifymeUsers";
const NotifyMeTable = (props) => {
  const {
    setShowDeleteDialog,
    setDeleteFunctionToUse,
    setIdToDelete,
    refreshKey,
  } = props;

  const history = useHistory();
  const location = useLocation();

  const cols = [
    {
      dataIndex: "first_name",
      title: "First Name",
      filterType: {
        dbCol: "notifyme_users.first_name",
        type: "string",
      },
      ellipsis: {
        showTitle: true,
      },
    },
    {
      dataIndex: "last_name",
      title: "Last Name",
      filterType: {
        dbCol: "notifyme_users.last_name",
        type: "string",
      },
      ellipsis: {
        showTitle: true,
      },
    },
    {
      dataIndex: "email",
      title: "Email",
      filterType: {
        dbCol: "notifyme_users.email",
        type: "string",
      },
      ellipsis: {
        showTitle: true,
      },
    },
    {
      dataIndex: "phone_number",
      title: "Phone Number",
      filterType: {
        dbCol: "notifyme_users.phone_number",
        type: "string",
      },
      ellipsis: {
        showTitle: true,
      },
    },
    {
      dataIndex: "created_at",
      title: "Created At",
      filterType: {
        dbCol: "notifyme_users.created_at",
        type: "date",
      },
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: "Actions",
      fixed: "right",
      render(text, record) {
        return (
          <button
            className="btn btn-danger btn-sm"
            style={{ width: "7em", cursor: "pointer" }}
            onClick={(event) => {
              event.stopPropagation();
              setShowDeleteDialog(true);
              setDeleteFunctionToUse("dashboard");
              setIdToDelete(record.notifyme_user_id);
            }}
          >
            Delete
            <i className="ion ion-md-trash ml-1" />
          </button>
        );
      },
    },
  ];

  return (
    <TableProvider
      params={{
        apiCallFn: async function (queryParams) {
          const res = await getNotifymeUsers({ queryParams });
          return {
            data: res.data,
            total: res.data?.metadata?.total || 0,
          };
        },
        initialPageSize: 10,
        config: {
          tableIdentifier: "get-notifyme-users-table",
          updateSearchQueryParams(newParams) {
            updateQueryParams({
              history,
              location,
              newParams,
            });
          },
        },
        initialSortCriteria: "-notifyme_users.created_at",
        deps: [refreshKey],
      }}
      components={DefaultTableComponents}
      columns={cols}
    >
      <DataTable pagination={false} />
      <MyPaginator />
    </TableProvider>
  );
};

export default NotifyMeTable;
